module.exports = __webpack_public_path__ + "media/images/curved-arrow-da94d28af7150f00dca545e8eaf6ae9a.svg";